import React from "react";
import { Table, Tooltip } from "@cloud/atom-ui";
import css from "../../index.m.css";
import { queryString } from "@src/utils/common";
import {
  TO_BE_PUBLISH_STATUS,
  UNDER_REVIEW_STATUS,
  PUBLISH_STATUS,
  REJECT_STATUS
} from "../../constant";

export default props => {
  const {
    deleteColumn,
    tableSource,
    tableLoading,
    clickVersionItem,
    paramsType
  } = props;
  const appId = queryString("id") || "";
  const appVersionRender = (_, record) => {
    switch (record.versionType) {
      case TO_BE_PUBLISH_STATUS:
        return <span style={{ color: "#689BF0" }}>待发布</span>;
      case UNDER_REVIEW_STATUS:
        return <span style={{ color: "#5ACCAA" }}>审核中</span>;
      case PUBLISH_STATUS:
        return <span style={{ color: "#595959" }}>已发布</span>;
      case REJECT_STATUS:
        return <span style={{ color: "#FF8870" }}>已驳回</span>;
      default:
        break;
    }
  };

  const textTip = text => {
    if (text?.length > 22) {
      return (
        <Tooltip placement="topLeft" title={text} trigger="hover">
          <span>{`${text?.slice(0, 22)}...`}</span>
        </Tooltip>
      );
    } else {
      return <span>{text}</span>;
    }
  };

  const columns = [
    {
      title: "版本号",
      dataIndex: "versionName",
      key: "versionName",
      className: `${css["version-table-column"]}`,
      width: "15%"
    },
    {
      title: "版本状态",
      dataIndex: "versionType",
      key: "versionType",
      className: `${css["version-table-column"]}`,
      render: appVersionRender,
      width: "15%"
    },
    {
      title: "发布人",
      dataIndex: "publisher",
      key: "publisher",
      className: `${css["version-table-column"]}`,
      width: "25%",
      render: text => {
        return textTip(text);
      }
    },
    {
      title: "发布时间",
      dataIndex: "publishTime",
      key: "publishTime",
      className: `${css["version-table-column"]}`,
      width: "25%"
    },
    {
      title: "操作",
      key: "action",
      render: (_, record) => {
        return (
          record.versionType === TO_BE_PUBLISH_STATUS && (
            <div className={css["href"]} onClick={() => deleteColumn()}>
              删除
            </div>
          )
        );
      }
    }
  ];

  return (
    <Table
      className={css["version-table"]}
      columns={columns}
      dataSource={tableSource}
      loading={tableLoading}
      onRow={record => {
        return {
          onClick: e => {
            if (e.target.className === css["href"]) {
              return;
            } else {
              clickVersionItem(record, appId, paramsType);
            }
          }
        };
      }}
      pagination={{
        pageSizeOptions: ["5", "10", "15", "20"],
        showQuickJumper: true,
        showSizeChanger: true
      }}
    />
  );
};
